import { motion } from "framer-motion";

const CTASection = () => {
    return (
        <section data-testid="cta-section" className="relative py-24 md:py-36 overflow-hidden paper-grid">
            <div className="relative max-w-[980px] mx-auto px-6 md:px-10 text-center">
                {/* Decorative hand-drawn arc */}
                <svg className="absolute -top-8 left-1/2 -translate-x-1/2 w-56 opacity-50 pointer-events-none" viewBox="0 0 200 60" fill="none" aria-hidden>
                    <motion.path
                        initial={{ pathLength: 0 }}
                        whileInView={{ pathLength: 1 }}
                        viewport={{ once: true }}
                        transition={{ duration: 2, ease: [0.16, 1, 0.3, 1] }}
                        d="M2 50 Q 100 -10, 198 50"
                        stroke="var(--coral)"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                </svg>

                <motion.h2
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    className="font-display text-[clamp(2.2rem,4.6vw,3.6rem)] leading-[1.04] tracking-tight font-semibold text-[var(--ink)]"
                >
                    Let&apos;s map your operations <span className="accent-blue">together.</span>
                </motion.h2>

                <motion.p
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.15 }}
                    className="mt-6 text-xl text-[var(--ink-soft)] max-w-xl mx-auto"
                >
                    No slides. No pitch deck. Bring whatever&apos;s burying your team — we&apos;ll show you what we&apos;d build.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 14 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.3 }}
                    className="mt-10 flex flex-col gap-3 items-center justify-center"
                >
                    <a
                        href="https://calendly.com/d/d3nd-zhb-2fr/lexafide-demo-discussion-30-minute-meeting-web"
                        target="_blank"
                        rel="noreferrer"
                        data-testid="cta-talk-btn"
                        className="btn-primary text-base inline-flex items-center gap-2"
                    >
                        <i className="fa-solid fa-calendar-days" />
                        Let&apos;s talk
                    </a>
                    <span className="text-[13px] text-[var(--ink-soft)]" data-testid="cta-terry-microcopy">
                        A working conversation with <span className="text-[var(--ink)] font-medium">one of our founders</span> — not a sales team.
                    </span>
                    <span className="font-mono text-xs tracking-wider text-[var(--ink-dim)] uppercase mt-1">
                        Avg. discovery to live agent: 14 days
                    </span>
                </motion.div>
            </div>
        </section>
    );
};

export default CTASection;
